<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}">
						<h4 class="card-title" id="headof"><i class="material-icons" (click)="back()">arrow_left</i> Tax reporting (AR / AP)</h4>
					</div>
					<div class="card-body">
						<form [formGroup]="formGroup" *ngIf="formGroup">
							<div class="row">
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="ml-2 mr-2 w-100-pct">
										<mat-label>From tax authority</mat-label>
										<mat-select formControlName="from_tax" (selectionChange)="onFromTaxChange($event.value)">
											<mat-option *ngFor="let a of allAuthorities" [value]="a.taxid">{{ a.description }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="ml-2 mr-2 w-100-pct">
										<mat-label>To tax authority</mat-label>
										<mat-select formControlName="to_tax">
											<mat-option *ngFor="let a of toAuthorityOptions" [value]="a.taxid">{{ a.description }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="ml-2 mr-2 w-100-pct">
										<mat-label>Return to period</mat-label>
										<mat-select formControlName="toperiod">
											<mat-option *ngFor="let p of periods" [value]="p.periodno">{{ p.lastdate_in_period }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="ml-2 mr-2 w-100-pct">
										<mat-label>Periods covered</mat-label>
										<mat-select formControlName="no_of_periods">
											<mat-option *ngFor="let c of noOfPeriodChoices" [value]="c.value">{{ c.label }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="ml-2 mr-2 w-100-pct">
										<mat-label>Detail / summary</mat-label>
										<mat-select formControlName="detail_or_summary">
											<mat-option *ngFor="let d of detailChoices" [value]="d.value">{{ d.label }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6 text-left">
									<ng-container *ngIf="report?.has_data">
										<button type="button" class="btn btn-success" (click)="exportXlsx()" [disabled]="exporting || loading" title="Export Excel">
											<i class="fa fa-file-excel-o"></i>
										</button>
										&nbsp;&nbsp;
										<button type="button" class="btn btn-danger" (click)="exportPdf()" [disabled]="exporting || loading" title="Export PDF">
											<i class="fa fa-file-pdf-o"></i>
										</button>
										<span *ngIf="exporting" class="tar-export-spinner">
											<svg class="spinner" width="30px" height="30px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
												<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
											</svg>
										</span>
									</ng-container>
								</div>
								<div class="col-md-6 text-right">
									<button mat-raised-button color="accent" (click)="runReport()" [disabled]="loading">Run</button>
								</div>
							</div>
						</form>

						<div class="row">
							<div class="col-md-12 text-center" *ngIf="loading">
								<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
									<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
								</svg>
							</div>
						</div>

						<p *ngIf="report && !loading && !report.has_data" class="text-muted mt-3">No tax entries for the selected criteria.</p>

						<ng-container *ngIf="report?.has_data && !loading">
							<div class="tar-print-root" #print_table>
								<p class="text-muted small mb-1" *ngIf="report.company_name">{{ report.company_name }}</p>
								<h3 class="mt-0">{{ report.title }}<span *ngIf="report.subtitle">: {{ report.subtitle }}</span></h3>
								<p class="mb-3">
									{{ report.no_of_periods }} period(s) to {{ report.period_end_display }} —
									AR periods {{ report.ar_from_period }}–{{ report.ar_to_period }},
									AP dates {{ report.purchase_date_from }} to {{ report.purchase_date_to }}
								</p>

								<ng-container *ngFor="let b of report.authorities">
									<h4 class="mt-3 tar-section-title">{{ b.description }}</h4>
									<ng-container *ngIf="report.detail">
										<h5 class="mt-2">Tax on sales (AR)</h5>
										<table class="table table-fixed table-striped table-hover table-sm table-fluid">
											<thead class="thead-dark">
												<tr>
													<th>Date</th>
													<th>Type</th>
													<th class="text-right">No.</th>
													<th>Name</th>
													<th>Branch</th>
													<th class="text-right">Net</th>
													<th class="text-right">Tax</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let ln of b.sales.lines">
													<td>{{ ln.trandate }}</td>
													<td>{{ ln.typename }}</td>
													<td class="text-right">{{ ln.transno }}</td>
													<td>{{ ln.name }}</td>
													<td>{{ ln.branchcode }}</td>
													<td class="text-right">{{ ln.netamount | currency }}</td>
													<td class="text-right">{{ ln.tax | currency }}</td>
												</tr>
											</tbody>
										</table>
										<h5 class="mt-2">Tax on purchases (AP)</h5>
										<table class="table table-fixed table-striped table-hover table-sm table-fluid">
											<thead class="thead-dark">
												<tr>
													<th>Date</th>
													<th>Type</th>
													<th class="text-right">No.</th>
													<th>Supplier</th>
													<th>Reference</th>
													<th class="text-right">Net</th>
													<th class="text-right">Tax</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let ln of b.purchases.lines">
													<td>{{ ln.trandate }}</td>
													<td>{{ ln.typename }}</td>
													<td class="text-right">{{ ln.transno }}</td>
													<td>{{ ln.suppname }}</td>
													<td>{{ ln.suppreference }}</td>
													<td class="text-right">{{ ln.netamount | currency }}</td>
													<td class="text-right">{{ ln.taxamt | currency }}</td>
												</tr>
											</tbody>
										</table>
									</ng-container>
									<table class="table table-fixed table-striped table-hover table-sm table-fluid mb-4">
										<thead class="thead-dark">
											<tr>
												<th class="title text-left"></th>
												<th class="text-right">Qty</th>
												<th class="text-right">Net</th>
												<th class="text-right">Tax</th>
												<th class="text-right">Total</th>
											</tr>
										</thead>
										<tbody>
											<tr class="tar-summary-row">
												<th class="text-left">Sales</th>
												<td class="text-right">{{ b.sales.count }}</td>
												<td class="text-right">{{ b.sales.net | currency }}</td>
												<td class="text-right">{{ b.sales.tax | currency }}</td>
												<td class="text-right">{{ b.sales.total | currency }}</td>
											</tr>
											<tr class="tar-summary-row">
												<th class="text-left">Purchases</th>
												<td class="text-right">{{ b.purchases.count }}</td>
												<td class="text-right">{{ b.purchases.net | currency }}</td>
												<td class="text-right">{{ b.purchases.tax | currency }}</td>
												<td class="text-right">{{ b.purchases.total | currency }}</td>
											</tr>
											<tr class="font-weight-bold tar-summary-diff">
												<th class="text-left">Difference</th>
												<td class="text-right">{{ b.difference.count }}</td>
												<td class="text-right">{{ b.difference.net | currency }}</td>
												<td class="text-right">{{ b.difference.tax | currency }}</td>
												<td class="text-right">{{ b.difference.total | currency }}</td>
											</tr>
										</tbody>
									</table>
								</ng-container>

								<h3 class="mt-4">Grand total</h3>
								<table class="table table-fixed table-striped table-hover table-sm table-fluid" *ngIf="report.grand">
									<thead class="thead-dark">
										<tr>
											<th class="title text-left"></th>
											<th class="text-right">Qty</th>
											<th class="text-right">Net</th>
											<th class="text-right">Tax</th>
											<th class="text-right">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr class="tar-summary-row">
											<th class="text-left">Sales</th>
											<td class="text-right">{{ report.grand.sales.count }}</td>
											<td class="text-right">{{ report.grand.sales.net | currency }}</td>
											<td class="text-right">{{ report.grand.sales.tax | currency }}</td>
											<td class="text-right">{{ report.grand.sales.total | currency }}</td>
										</tr>
										<tr class="tar-summary-row">
											<th class="text-left">Purchases</th>
											<td class="text-right">{{ report.grand.purchases.count }}</td>
											<td class="text-right">{{ report.grand.purchases.net | currency }}</td>
											<td class="text-right">{{ report.grand.purchases.tax | currency }}</td>
											<td class="text-right">{{ report.grand.purchases.total | currency }}</td>
										</tr>
										<tr class="font-weight-bold tar-summary-diff">
											<th class="text-left">Difference</th>
											<td class="text-right">{{ report.grand.difference.count }}</td>
											<td class="text-right">{{ report.grand.difference.net | currency }}</td>
											<td class="text-right">{{ report.grand.difference.tax | currency }}</td>
											<td class="text-right">{{ report.grand.difference.total | currency }}</td>
										</tr>
									</tbody>
								</table>
								<p class="small text-muted mt-3" *ngFor="let fn of report.footnotes">{{ fn }}</p>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
